// Helper that turns a single gallery image array into a product-type-keyed map
// for `ProductTypeStep`'s `productImages` prop. The same gallery feeds the
// "cover_and_foam" and "cover_only" sets (with a slight slice offset so the
// imagery shifts when the user changes selection), and "foam_only" uses
// dedicated foam-related artwork from /public.
const FOAM_ONLY_IMAGES = [
  { src: '/foam-texture.png', alt: 'High-density foam interior' },
  { src: '/product-type-foam-only.png', alt: 'Custom-cut foam insert' },
];

export const buildProductImages = (gallery = []) => {
  const safe = Array.isArray(gallery) ? gallery : [];
  const fallback = safe.slice(0, 2);
  const coverOnly = safe.length >= 3 ? safe.slice(1, 3) : fallback;
  return {
    cover_and_foam: fallback,
    cover_only: coverOnly,
    foam_only: FOAM_ONLY_IMAGES,
  };
};

export default buildProductImages;
